module.exports = {"411622001":"娲城街道","411622002":"箕子台街道","411622003":"昆山街道","411622101":"西夏亭镇","411622102":"逍遥镇","411622103":"奉母镇","411622104":"红花集镇","411622105":"聂堆镇","411622106":"东夏亭镇","411622107":"西华营镇","411622108":"址坊镇","411622200":"田口乡","411622201":"清河驿乡","411622202":"皮营乡","411622203":"东王营乡","411622204":"大王庄乡","411622205":"李大庄乡","411622206":"叶埠口乡","411622207":"迟营乡","411622208":"黄土桥乡","411622209":"艾岗乡","411622405":"黄泛区农场","411622406":"五二农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411622.json
// module id = 1530
// module chunks = 0